import { Helmet } from 'react-helmet-async'
import { useRouteContext } from '@/shared/hooks/use-route-context'

export function DocumentHead() {
  const { documentTitle } = useRouteContext()

  return (
    <Helmet>
      <title>{documentTitle}</title>
    </Helmet>
  )
}
